import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "@auth0/auth0-react";
import history from "./utils/history";
import { getConfig } from "./config";
import {
  initChunkReloadGuard,
  installChunkReloadHandlers,
} from "./utils/chunkReload";

initChunkReloadGuard();
installChunkReloadHandlers();

// Belt-and-suspenders with public/index.html: YouTube embeds emit opaque
// cross-origin "Script error." events that CRA's overlay treats as fatal.
if (typeof window !== "undefined") {
  const isOpaqueScriptError = (message, filename) => {
    const msg = String(message || "");
    return (
      (msg === "Script error." || msg === "Script error") && !filename
    );
  };
  window.addEventListener(
    "error",
    (event) => {
      if (isOpaqueScriptError(event?.message, event?.filename)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event?.reason;
      const message = reason?.message || String(reason || "");
      if (isOpaqueScriptError(message, "")) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const onRedirectCallback = (appState) => {
  history.push(appState?.returnTo || window.location.pathname);
};

const config = getConfig();

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={config.domain}
    clientId={config.clientId}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    onRedirectCallback={onRedirectCallback}
    scope="openid profile email offline_access"
    authorizationParams={{
      redirect_uri: window.location.origin, // Moved redirectUri here
      audience: config.audience || undefined,
      scope: "openid profile email offline_access",
    }}
  >
    <App />
  </Auth0Provider>,
);

serviceWorker.unregister();
